import { ShareClass } from '../../models/entity';
import { ConditionalDataConfig } from '../../models/configuration/ConditionalDataConfig';
import pivotQueryCollection from './pivotQueryCollection';
import getQueryResults from './getQueryResults';
import { IEntity } from '../../models/commonTypes';

export default function getConditionalData(
    shareClass: ShareClass,
    config: ConditionalDataConfig
) {
    if (config && config.queries) {
        const queryContext = {
            entityByType: {
                CLSS: shareClass as IEntity,
            },
        };
        const queries = pivotQueryCollection(config.queries);
        const results = getQueryResults(queryContext, queries);
        return results;
    }
    return {};
}



// WEBPACK FOOTER //
// ./src/utils/query/getConditionalData.ts